export const TEXT_POSITIONS = {
  CENTER: 'center',
  LEFT: 'left',
  RIGHT: 'right',
};
